import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import { Moment } from '../../helpers'

export const JobDateTime = ({ datetime, jobStatus }) => {
  const [fontcolor, setFontColor] = useState()

  useEffect(() => {
    switch (jobStatus) {
      case -2:
        setFontColor('red')
        break
      case -1:
        setFontColor('red')
        break
      case 1:
        setFontColor('#068a1a')
        break
      case 2:
        setFontColor('#068a8a')
        break
      case 3:
        setFontColor('#797a7a')
        break
    }
  })

  // แสดงวันที่
  const showFormatDate = (datetime) => {
    let date = Moment(datetime)
    if (date.isValid()) {
      return <span style={{ color: '#222222' }}>{date.format('ll')}</span>
    } else {
      return
    }
  }
  // แสดงเวลา
  const showFormatTime = (datetime) => {
    const time = Moment(datetime)
    if (time.isValid()) {
      return (
        <Button shape="round" style={{ color: fontcolor }} size="small">
          {time.format('LT')} น.
        </Button>
      )
    } else {
      return
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          display: 'inline-block',
        }}
      >
        <div align="center">
          {datetime ? showFormatDate(datetime) : ''}
          {datetime ? (<div>{showFormatTime(datetime)}</div>) : ''}
        </div>
      </div>
    </React.Fragment>
  )
}
